module.exports = __webpack_public_path__ + "img/phone arrow.23dc3447.svg";